import { getAll } from '@/services/api';
import {
  buildCommercialBillingSectionData,
  findCommercialBillingSection,
} from '@/components/SiderMenu/utils/sessionNavigation';
import {
  SESSION_TYPES,
  STORAGE_KEYS,
  getCurrentSession,
  getSessionItem,
} from '@/utils/infrastructure/auth';

const isProcessPortalRuntime = (portal) => {
  if (portal) return true;
  if (getCurrentSession()?.type === SESSION_TYPES.PORTAL) return true;
  if (getSessionItem(STORAGE_KEYS.PORTAL_CONFIG)) return true;
  if (typeof window !== 'undefined' && window.location.pathname.startsWith('/p/')) return true;
  return false;
};

const initialState = {
  channelActorKind: null,
  commercialBillingSectionTitle: null,
  commercialBillingMenuItems: [],
  commercialBillingApiRoutes: {},
};

const SessionNavigationModel = {
  namespace: 'sessionNavigation',
  state: initialState,

  effects: {
    *fetchNavigation(_, { call, put, select }) {
      const portal = yield select((state) => state.companyPortal?.portal);
      if (isProcessPortalRuntime(portal)) return;

      try {
        const response = yield call(getAll, { route: 'me/navigation' });
        yield put({ type: 'setNavigation', payload: response });
      } catch (e) {
        yield put({ type: 'reset' });
      }
    },
  },

  reducers: {
    setNavigation(state, { payload }) {
      const section = findCommercialBillingSection(payload?.sections);
      const { menuItems, apiRoutes } = buildCommercialBillingSectionData(section);

      return {
        ...state,
        channelActorKind: payload?.channelActorKind ?? null,
        commercialBillingSectionTitle: section?.title ?? null,
        commercialBillingMenuItems: menuItems,
        commercialBillingApiRoutes: apiRoutes,
      };
    },

    reset() {
      return { ...initialState };
    },
  },
};

export default SessionNavigationModel;
